import { useTranslation } from "react-i18next";
import styles from "./messages.module.scss"

const MESSAGES_LIST = [
    {
        state: 0, // 0: 未读, 1: 已读
        messageKey: "mindplus_update_notice",
        time: "2025.09.17"
    },
    {
        state: 0,
        messageKey: "creator_journal_welcome",
        time: "2025.07.17"
    },
    {
        state: 1,
        messageKey: "creator_journal_welcome",
        time: "2025.05.17"
    },
    {
        state: 0,
        messageKey: "creator_journal_welcome",
        time: "2025.03.17"
    }
]
export const Messages = () => {
    const { t } = useTranslation();
     
    return (
        <div className={styles.messagesSetting} >
            {MESSAGES_LIST.map(item => {
                return (
                    <div className={styles.messagesItem}>
                        <div className={styles.info}>
                            <div className={styles.text}>{t(item.messageKey) as string}</div>
                            {!item.state && <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="12" height="12" viewBox="0 0 12 12"><g><ellipse cx="6" cy="6" rx="6" ry="6" fill="#FF8500" fill-opacity="1"/></g></svg>}
                        </div>
                        <div className={styles.time}>{item.time}</div>
                    </div>
                )
            })} 
        </div>
    );
};